import { getCompatConfig } from '../compat.js';

function returnSetter(set) {
  return set;
}
const delayedTrackZustand = (f, name) => {
  return (set, get, api) => {
    let loggedSet = null;
    const dynamicSet = (...args) => {
      const zustandPlugin = getCompatConfig().OPENREPLAY.zustandPlugin;
      if (zustandPlugin && !loggedSet) {
        loggedSet = zustandPlugin(returnSetter, name)(set, get, api);
      }
      if (loggedSet) {
        loggedSet(...args);
      } else {
        set(...args);
      }
    };
    return f(dynamicSet, get, api);
  };
};

export { delayedTrackZustand };
//# sourceMappingURL=openreplay.js.map
